const ANIMATION = [
  {
    opacity: 0,
    transform: "translateY(30px)",
  },
  {
    opacity: 1,
    transform: "none",
  },
];
const DURATION = 1000;

export default function createAnimation(ref) {
  const element = ref.current;
  let callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.animate(ANIMATION, DURATION);
        // Uncomment to keep components in place after loading
        // observer.unobserve(element);
      }
    });
  };
  let observer = new IntersectionObserver(callback);
  observer.observe(element);
}
